import * as c from 'common/c'
import type { Operator } from 'state/account'

export const operatorsFetched = (data: Operator[]) => {
  return {
    type: c.OPERATORS_FETCHED,
    payload: data,
  }
}

export const operatorCreated = (data: Operator) => {
  return {
    type: c.CREATE_OPERATOR,
    payload: data,
  }
}

export const operatorEdited = (data: Operator) => {
  return {
    type: c.UPDATE_OPERATOR,
    payload: data,
  }
}

export const operatorDeleted = (id: string) => {
  return {
    type: c.DELETE_OPERATOR,
    payload: id,
  }
}
